import React from "react";
import SpotlightSlider from "../SpotlightSlider/SpotlightSlider";

import {
  SliderCont,
  SpotlightContent,
  SpotlightSection,
} from "./Spotlight.styles";

interface ISpotLightNews {
  id: number;
  mediaName: string;
  heading: string;
  date: string;
  link: string;
}
interface ISpotLight {
  title: string;
  subTitle: string;
  spotLightNews: ISpotLightNews[];
  footerArrow: string;
}

const Spotlight = ({
  title,
  subTitle,
  spotLightNews,
  footerArrow,
}: ISpotLight) => {
  return (
    <SpotlightSection id="spotLight">
      <SpotlightContent>
        <h2>{title}</h2>
        <h3>{subTitle}</h3>
        <SliderCont>
          <SpotlightSlider data={spotLightNews} footerArrow={footerArrow} />
        </SliderCont>
      </SpotlightContent>
    </SpotlightSection>
  );
};

export default Spotlight;
